import {APIProvider} from "@vis.gl/react-google-maps";
import {Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import {LocationsMap} from "./locationsMap";


export function LocationsWrapper() {

    const [apiKey, setApiKey] = useState<string>('AIzaSyBpj2zVCpa9s0erzIU1GJpiB38lMq6z5XA')

    useEffect(() => {

    }, []);

    return <Grid className={'react-locations'}>
        <APIProvider apiKey={apiKey}>
            <LocationsMap/>
        </APIProvider>
    </Grid>
}
